import React from "react";

const SearchBar = ({ dataSearch, setDataSearch, onSearch }) => {

    const handleInputChange = (field) => (e) => {
        let value = '';
        if (e && e.target && typeof e.target.value !== 'undefined') {
            value = e.target.value;
        }
        setDataSearch(prev => ({ ...(prev || {}), [field]: value }));
    };

    const handleSearch = (e) => {
        if (e) e.preventDefault();
        onSearch({ ...dataSearch, PageIndex: 1 });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch(e);
        }
    };
    const renderInput = () => (
        <input
            type="text"
            className="form-control input-sm"
            placeholder="Tìm kiếm tên hợp đồng..."
            value={dataSearch.sContractName || ""}
            onChange={handleInputChange("sContractName")}
            onKeyDown={handleKeyDown}
        />
    );

    return (
        <>
            <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2" style={{ marginBottom: 16 }}>
                <div className="card-body card-body-v2" style={{ padding: '12px 16px 8px 16px' }}>
                    <div className="search-new d-flex flex-row align-items-end justify-content-start gap-3">
                        <div className="input-sm-new input-new-18" style={{ flex: 1 }}>
                            <label className="font-color-default font-bold">Tên hợp đồng</label>
                            {renderInput()}
                        </div>
                        <div className="input-sm-new input-new-18 search-main-new">
                            <button
                                type="submit"
                                className="btn btn-info-new"
                                style={{ paddingTop: "7px" }}
                                onClick={handleSearch}
                            >
                                <i className="la la-search"></i>
                                <span> &nbsp; Tìm kiếm</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                <div className="card border-light mb-2 card-v2">
                    <div className="card-body card-body-v2" style={{ padding: '10px' }}>
                        <div className="d-flex gap-2 align-items-center">
                            <div style={{ flex: 1 }}>
                                {renderInput()}
                            </div>
                            <button
                                type="button"
                                className="btn btn-info"
                                onClick={handleSearch}
                                style={{ whiteSpace: "nowrap", height: '34px' }} 
                            >
                                <i className="la la-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SearchBar;